export const navigate = (history, url) => history?.push(url);

export const goBackHome = history => history?.push('/');

export const isPublicRouteAccess = ({ code, allowPathCode, search }) => {
	const searchParams = new URLSearchParams(search);

	return Boolean(allowPathCode && code) || searchParams.has('token') || searchParams.has('code');
};
